import { SimpleGrid, Checkbox, Text } from '@chakra-ui/react';
import { usePartnerForm } from '../../hooks/usePartnerForm';
import { FORM_FIELD_PATHS } from '../../constants';

const invoiceExportToggles = [
    {
        key: 'billShowRGS',
        label: 'RGS Details',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_RGS,
    },
    {
        key: 'billShowCompany',
        label: 'Company Details',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_COMPANY,
    },
    {
        key: 'billShowUsers',
        label: 'User Details',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_USERS,
    },
    {
        key: 'billShowTrunk',
        label: 'Trunk Details',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_TRUNK,
    },
    {
        key: 'billShowNumberBlock',
        label: 'Number Block Details',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_NUMBER_BLOCK,
    },
    {
        key: 'billShowZero',
        label: '$0 Items',
        formPath: FORM_FIELD_PATHS.BILL_SHOW_ZERO,
    },
];

const InvoiceExportToggles = () => {
    const { formData, updateFormData } = usePartnerForm();

    return (
        <SimpleGrid columns={4} spacingY={2} spacingX={8} width="100%" py={2}>
            {invoiceExportToggles.map((toggle) => (
                <Checkbox
                    key={toggle.key}
                    isChecked={
                        formData.partnerBillingSettings?.[toggle.key] || false
                    }
                    isDisabled={
                        formData.partnerBillingSettings?.billOneLine === true
                    }
                    onChange={(e) =>
                        updateFormData(
                            `${FORM_FIELD_PATHS.BILLING_SETTINGS}.${toggle.key}`,
                            e.target.checked,
                        )
                    }
                    display="flex"
                    alignItems="center"
                    height="40px"
                    sx={{ verticalAlign: 'middle' }}>
                    <Text
                        fontSize="13px"
                        lineHeight="40px"
                        height="40px"
                        display="flex"
                        alignItems="center">
                        {toggle.label}
                    </Text>
                </Checkbox>
            ))}
        </SimpleGrid>
    );
};

export default InvoiceExportToggles;
